export default __webpack_public_path__ + "static/media/stash.12f0f81a.svg";